import type { SolutionPageContent } from '../../types/solution'
import { retailSolution } from './retail'
import { foodBeverageSolution } from './foodBeverage'
import { manufacturingSolution } from './manufacturing'
import { servicesSolution } from './services'
import { hospitalitySolution } from './hospitality'
import { healthcareSolution } from './healthcare'
import { sellAndGetPaidSolution } from './sellAndGetPaid'
import { manageInventorySolution } from './manageInventory'
import { controlExpensesSolution } from './controlExpenses'
import { understandPerformanceSolution } from './understandPerformance'
import { manageMultipleLocationsSolution } from './manageMultipleLocations'
import { accessBusinessFinanceSolution } from './accessBusinessFinance'

export const solutionPages: Record<string, SolutionPageContent> = {
  retail: retailSolution,
  'food-beverage': foodBeverageSolution,
  manufacturing: manufacturingSolution,
  services: servicesSolution,
  hospitality: hospitalitySolution,
  healthcare: healthcareSolution,
  'sell-and-get-paid': sellAndGetPaidSolution,
  'manage-inventory': manageInventorySolution,
  'control-expenses': controlExpensesSolution,
  'understand-performance': understandPerformanceSolution,
  'manage-multiple-locations': manageMultipleLocationsSolution,
  'access-business-finance': accessBusinessFinanceSolution,
}
